<template>
    <review-board course-source="Special"></review-board>
</template>

<script>
import ReviewBoard from './ReviewBoard.vue';

export default {
    name: 'ClassroomQualitySpecialReview',
    components: { ReviewBoard },
};
</script>
